import { useState, useEffect } from 'react'
import { supabase, funzioneUrl } from '../lib/supabase'
import ModaleConferma from './ModaleConferma'
import { useAuth } from '../lib/AuthContext'
import PaginaGuida from './PaginaGuida'
import PaginaLegale from './PaginaLegale'
import TopBar from './TopBar'
import { pushSupportato, serveInstallazioneIOS, statoPermessoPush, abilitaNotifichePush, disabilitaNotifichePush, sincronizzaPush, diagnosticaPush, comeSbloccareNotifiche } from '../lib/pushNotifications'

export default function PaginaProfilo({ onTemaChange, apriRichieste: apriRichiesteProp, onApriRichiesteConsumed, coachPremium, isCoach }) {
  const { profilo, esci, caricaProfilo } = useAuth()
  const [nome, setNome] = useState(profilo?.nome || '')
  const [cognome, setCognome] = useState(profilo?.cognome || '')
  const [nuovaPassword, setNuovaPassword] = useState('')
  const [confermaPassword, setConfermaPassword] = useState('')
  const [mostraPass, setMostraPass] = useState(false)
  const [temaChiaro, setTemaChiaro] = useState(localStorage.getItem('fp_tema') === 'light')
  const [toast, setToast] = useState('')
  const [conferma, setConferma] = useState(null)
  const [errore, setErrore] = useState('')
  const [caricamento, setCaricamento] = useState(false)
  const [pagamentoCaricamento, setPagamentoCaricamento] = useState(false)
  const [mostraGuida, setMostraGuida] = useState(false)

  // ── Richieste utente ──
  const [mostraRichieste, setMostraRichieste] = useState(false)
  const [richiesteUtente, setRichiesteUtente] = useState([])
  const [nuovaRichiestaOpen, setNuovaRichiestaOpen] = useState(false)
  const [richCategoria, setRichCategoria] = useState('nuovo_esercizio')
  const [richTitolo, setRichTitolo] = useState('')
  const [richTesto, setRichTesto] = useState('')
  const [richInvio, setRichInvio] = useState(false)
  const [richErrore, setRichErrore] = useState('')
  const [paginaLegale, setPaginaLegale] = useState(null)
  const [referralCode, setReferralCode] = useState(null)
  const [referralCaricamento, setReferralCaricamento] = useState(false)
  const [referralUtilizzi, setReferralUtilizzi] = useState(0)
  const [confermaCancellazione, setConfermaCancellazione] = useState(false)
  const [testoConferma, setTestoConferma] = useState('')
  const [cancellando, setCancellando] = useState(false)
  const [notifichePushOn, setNotifichePushOn] = useState(false)
  const [notifichePushCaricamento, setNotifichePushCaricamento] = useState(false)
  const [pushErrore, setPushErrore] = useState('')
  const [pushDiagnostica, setPushDiagnostica] = useState('')

  // Funzione "regala abbonamento" rimossa: con il modello freemium l'atleta è sempre
  // gratuito (nulla da regalare) e il coach, se vuole Premium, paga direttamente
  // dal proprio profilo — niente più regali in entrata per il coach.

  function toast_msg(msg) { setToast(msg); setTimeout(() => setToast(''), 2500) }

  // Stato iniziale dell'interruttore notifiche push.
  // sincronizzaPush() non si limita a leggere: se il browser è ancora iscritto
  // ma la riga nel database manca, la riscrive. Prima si guardava solo lo stato
  // del browser, e l'interruttore poteva restare verde mentre il server non
  // aveva più alcun modo di raggiungere il dispositivo.
  useEffect(() => {
    if (!profilo?.id) return
    if (!pushSupportato() && !serveInstallazioneIOS()) return
    let annullato = false
    ;(async () => {
      const stato = await sincronizzaPush(profilo.id)
      if (annullato) return
      setNotifichePushOn(stato)
      const d = await diagnosticaPush(profilo.id)
      if (!annullato) setPushDiagnostica(d.riassunto)
    })()
    return () => { annullato = true }
  }, [profilo?.id])

  async function toggleNotifichePush() {
    if (notifichePushCaricamento) return
    setNotifichePushCaricamento(true)
    setPushErrore('')
    try {
      if (notifichePushOn) {
        await disabilitaNotifichePush(profilo.id)
        setNotifichePushOn(false)
      } else {
        const ris = await abilitaNotifichePush()
        if (ris.ok) {
          setNotifichePushOn(true)
          toast_msg('🔔 Notifiche attive su questo dispositivo')
        } else {
          // Messaggio che RESTA sulla scheda. Prima l'unica traccia di un
          // errore era un toast da 2,5 secondi: spariva prima che si potesse
          // leggere, e l'interruttore sembrava semplicemente non funzionare.
          console.error('[push] attivazione:', ris.motivo, ris.dettaglio || '')
          setPushErrore(
            ris.motivo === 'permesso-negato'
              ? 'Il browser ha negato il permesso. ' + comeSbloccareNotifiche()
            : ris.motivo === 'non-supportato'
              ? 'Questo browser non supporta le notifiche push.'
            : ris.motivo === 'errore-salvataggio'
              ? 'Permesso concesso, ma la registrazione sul server non è riuscita: ' + (ris.dettaglio || 'errore non specificato')
            : 'Attivazione non riuscita: ' + (ris.dettaglio || ris.motivo)
          )
        }
      }
      const d = await diagnosticaPush(profilo.id)
      setPushDiagnostica(d.riassunto)
    } finally {
      // In un finally: se qualcosa va storto l'interruttore deve tornare
      // utilizzabile, non restare bloccato in attesa per il resto della sessione.
      setNotifichePushCaricamento(false)
    }
  }

  // Carica o genera il codice referral dell'utente
  // FIX: usa prop invece di window flag per evitare race condition
  useEffect(() => {
    if (apriRichiesteProp) {
      apriRichieste()
      if (onApriRichiesteConsumed) onApriRichiesteConsumed()
    } else if (window.__apriRichieste) {
      // Compatibilità con HomeAtleta che usa ancora il flag
      delete window.__apriRichieste
      apriRichieste()
    }
  }, [apriRichiesteProp])

  useEffect(() => {
    if (!profilo?.id || profilo?.piano === 'admin') return
    supabase.from('referral_codes')
      .select('codice, utilizzi')
      .eq('utente_id', profilo.id)
      .maybeSingle()
      .then(({ data }) => {
        if (data) {
          setReferralCode(data.codice)
          setReferralUtilizzi(data.utilizzi || 0)
        }
      })
  }, [profilo?.id])

async function eliminaAccount() {
    if (testoConferma !== 'ELIMINA') {
      toast_msg('Devi scrivere ELIMINA per confermare')
      return
    }
    setCancellando(true)
    try {
      const userId = profilo.id
      // I dati personali NON si cancellano qui a mano. Cancellare l'utente in
      // auth.users li porta via tutti per cascata (profili.id ha una foreign key
      // ON DELETE CASCADE, e da profili cascata il resto). Farlo prima era
      // pericoloso: se la cancellazione dell'account poi falliva — ed è
      // esattamente quello che succedeva — i dati erano già persi e il login
      // restava vivo, con la mail occupata e nessun modo di re-registrarsi.
      //
      // Se è coach: i suoi gruppi si eliminano solo se NON contengono dati degli atleti.
      // Cancellare il proprio account è un diritto, ma riguarda i propri dati: i risultati
      // registrati dagli atleti sono loro, e sparivano insieme al coach.
      // I gruppi con allenamenti svolti restano, chiusi e senza coach (il vincolo nel
      // database mette gestore_id a NULL): gli atleti conservano storico e progressi.
      const { data: gruppiCreati } = await supabase.from('gruppi').select('id').eq('gestore_id', userId)
      if (gruppiCreati?.length) {
        const gruppoIds = gruppiCreati.map(g => g.id)
        const { data: date } = await supabase.from('sessioni_calendario').select('id, gruppo_id').in('gruppo_id', gruppoIds)
        const { data: conRisultati, error: errRis } = await supabase.rpc('calendari_con_risultati', { ids: (date || []).map(d => d.id) })
        // Se il controllo non risponde non si procede: meglio un account non eliminato
        // che i dati di altri atleti cancellati per errore.
        if (errRis) { toast_msg('Impossibile verificare i dati dei gruppi, riprova'); setCancellando(false); return }
        const idConRisultati = new Set((conRisultati || []).map(r => (typeof r === 'string' ? r : r.calendari_con_risultati)))
        const gruppiDaTenere = new Set((date || []).filter(d => idConRisultati.has(d.id)).map(d => d.gruppo_id))
        const gruppiDaEliminare = gruppoIds.filter(id => !gruppiDaTenere.has(id))
        if (gruppiDaEliminare.length > 0) {
          await supabase.from('sessioni_calendario').delete().in('gruppo_id', gruppiDaEliminare)
          await supabase.from('sessioni_tipo').delete().in('gruppo_id', gruppiDaEliminare)
          await supabase.from('gruppo_membri').delete().in('gruppo_id', gruppiDaEliminare)
          await supabase.from('gruppi').delete().in('id', gruppiDaEliminare)
        }
        if (gruppiDaTenere.size > 0) {
          await supabase.from('gruppi').update({ attivo: false }).in('id', [...gruppiDaTenere])
        }
      }
      // Cancellazione dell'account: è il passo che porta via tutto il resto.
      // Il profilo deve ESISTERE ancora quando si chiama la funzione, perché è
      // da lì che verifica la mail di conferma.
      const { data: { session } } = await supabase.auth.getSession()
      const risposta = await fetch(funzioneUrl('delete-user'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
        body: JSON.stringify({ targetId: userId, confermaEmail: profilo.email }),
      })
      const esito = await risposta.json().catch(() => ({}))

      // La risposta va controllata. Prima non lo era: la chiamata falliva
      // sempre (corpo sbagliato, non admin, profilo già cancellato) e l'utente
      // veniva disconnesso credendo di aver cancellato l'account.
      if (!risposta.ok || !esito?.success) {
        console.error('[eliminaAccount] delete-user:', risposta.status, esito)
        toast_msg('Account NON cancellato: ' + (esito?.error || `errore ${risposta.status}`))
        setCancellando(false)
        return
      }

      // Solo ora si esce: l'account non esiste più davvero.
      await supabase.auth.signOut()
      window.location.href = '/'
    } catch (e) {
      console.error('Errore cancellazione account:', e)
      toast_msg('Errore durante la cancellazione: ' + e.message)
      setCancellando(false)
    }
  }

  function toggleTema() {
    const nuovoTema = temaChiaro ? 'dark' : 'light'
    setTemaChiaro(!temaChiaro)
    localStorage.setItem('fp_tema', nuovoTema)
    document.documentElement.setAttribute('data-theme', nuovoTema === 'light' ? 'light' : '')
    onTemaChange && onTemaChange(nuovoTema)
  }

  async function avviaPagamento() {
    setPagamentoCaricamento(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session?.user) throw new Error('Sessione non trovata')
      const response = await fetch(
        funzioneUrl('create-checkout-session'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${session.access_token}`,
          },
          body: JSON.stringify({ piano: profilo?.piano || 'atleta' }),
        }
      )
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || 'Errore dal server')
      if (!data?.url) throw new Error('URL pagamento non ricevuto')
      window.location.href = data.url
    } catch (err) {
      toast_msg('Errore: ' + err.message)
      setPagamentoCaricamento(false)
    }
  }

  /**
   * Codice referral personale, tipo FP-ANDRE42.
   *
   * referral_codes.codice ha un vincolo di unicità, e il codice è composto dalle
   * prime 5 lettere del nome più due cifre: due utenti con lo stesso nome hanno
   * 90 codici possibili in tutto. Alla prima collisione l'insert veniva
   * rifiutata, l'errore grezzo di Postgres finiva nel toast e il pulsante non
   * riprovava: per quell'utente il codice non si generava più. Ora ritenta con
   * un numero diverso.
   */
  async function generaCodiceReferral() {
    setReferralCaricamento(true)
    const base = (profilo?.nome || 'USER').toUpperCase().replace(/[^A-Z]/g, '').substring(0, 5) || 'USER'
    let ultimoErrore = null

    for (let tentativo = 0; tentativo < 10; tentativo++) {
      const codice = `FP-${base}${Math.floor(10 + Math.random() * 90)}`
      const { data, error } = await supabase.from('referral_codes')
        .insert({ utente_id: profilo.id, codice })
        .select('codice, utilizzi')
        .single()

      if (!error) {
        setReferralCaricamento(false)
        setReferralCode(data.codice)
        setReferralUtilizzi(data.utilizzi || 0)
        return
      }
      ultimoErrore = error

      // utente_id è unico a sua volta: se l'utente ha GIÀ un codice (doppio
      // tocco, o un'altra scheda aperta) non si insiste con numeri nuovi — si
      // legge quello che c'è già e si mostra quello.
      if (error.code === '23505' && error.message?.includes('utente_id')) {
        const { data: suo } = await supabase.from('referral_codes')
          .select('codice, utilizzi').eq('utente_id', profilo.id).maybeSingle()
        setReferralCaricamento(false)
        if (suo) { setReferralCode(suo.codice); setReferralUtilizzi(suo.utilizzi || 0); return }
        break
      }
      // Un errore che non sia una collisione non si risolve ritentando.
      if (error.code !== '23505') break
    }

    setReferralCaricamento(false)
    toast_msg('Codice non generato: ' + (ultimoErrore?.message || 'riprova'))
  }

  async function caricaRichieste() {
    if (!profilo?.id) return
    const { data } = await supabase.from('richieste_utente')
      .select('*').eq('utente_id', profilo.id).order('creata_il', { ascending: false }).limit(20)
    setRichiesteUtente(data || [])
  }

  async function eliminaRichiesta(richiestaId) {
    const { error } = await supabase.from('richieste_utente').delete().eq('id', richiestaId).eq('utente_id', profilo.id)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('🗑️ Richiesta eliminata')
    await caricaRichieste()
  }

  async function apriRichieste() {
    setMostraRichieste(true)
    await caricaRichieste()
  }

  function chiudiRichieste() {
    setMostraRichieste(false)
    setNuovaRichiestaOpen(false)
  }

  async function inviaRichiesta() {
    setRichErrore('')
    if (!richTitolo.trim()) { setRichErrore('Inserisci un titolo'); return }
    if (!richTesto.trim()) { setRichErrore('Descrivi la tua richiesta'); return }
    setRichInvio(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      // 1. Salva la richiesta nel DB
      const { data, error } = await supabase.from('richieste_utente').insert({
        utente_id: profilo.id,
        utente_email: profilo.email,
        utente_nome: profilo.nome || profilo.email,
        categoria: richCategoria,
        titolo: richTitolo.trim(),
        testo: richTesto.trim(),
      }).select().single()
      if (error) { setRichErrore('Errore: ' + error.message); setRichInvio(false); return }

      // 2. Crea notifiche in-app per tutti gli admin
      const { data: admins } = await supabase.from('profili').select('id').eq('piano', 'admin')
      if (admins && admins.length > 0) {
        const categoriaLabel = { nuovo_esercizio: 'Nuovo esercizio', bug: 'Bug', miglioramento: 'Miglioramento', altro: 'Altro' }[richCategoria]
        const notifiche = admins.map(a => ({
          utente_id: a.id,
          titolo: `📩 Nuova richiesta: ${categoriaLabel}`,
          testo: `${profilo.nome || profilo.email}: ${richTitolo.trim().slice(0, 100)}`,
          tipo: 'richiesta_utente',
          dati: JSON.stringify({ richiesta_id: data.id }),
          letta: false,
        }))
        await supabase.from('notifiche').insert(notifiche)
      }

      // 3. Email a info@fitprogress.it (admin)
      try {
        const r = await fetch(funzioneUrl('send-gift-email'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session.access_token}` },
          body: JSON.stringify({
            tipo: 'richiesta_admin',
            destinatario_email: 'info@fitprogress.it',
            categoria: richCategoria,
            titolo_richiesta: richTitolo.trim(),
            testo_richiesta: richTesto.trim(),
            mittente_nome: profilo.nome || profilo.email,
            mittente_email: profilo.email,
          }),
        })
        if (!r.ok) {
          const err = await r.json().catch(() => ({}))
          console.error('[richiesta_admin] email errore:', r.status, err)
        }
      } catch (e) {
        console.error('[richiesta_admin] email fetch errore:', e)
      }

      toast_msg('✅ Richiesta inviata!')
      setNuovaRichiestaOpen(false)
      setRichTitolo(''); setRichTesto(''); setRichCategoria('nuovo_esercizio')
      caricaRichieste()
    } catch (e) {
      setRichErrore('Errore di connessione: ' + e.message)
    }
    setRichInvio(false)
  }

  async function condividiReferral() {
    const link = `https://fitprogress.it?ref=${referralCode}`
    const testo = `Prova FitProgress — l'app per il tuo allenamento! Usa il mio codice invito per registrarti: ${link}`
    if (navigator.share) {
      try { await navigator.share({ title: 'FitProgress', text: testo, url: link }) } catch {}
    } else {
      navigator.clipboard.writeText(link)
      toast_msg('✓ Link copiato!')
    }
  }

  async function salvaDati() {
    if (!nome.trim()) { setErrore('Il nome non puo essere vuoto'); return }
    setCaricamento(true)
    setErrore('')
    const { error } = await supabase.from('profili').update({ nome, cognome }).eq('id', profilo.id)
    setCaricamento(false)
    if (error) { setErrore('Errore: ' + error.message); return }
    caricaProfilo(profilo.id)
    toast_msg('Dati aggiornati!')
  }

  async function cambiaPassword() {
    if (!nuovaPassword) { setErrore('Inserisci la nuova password'); return }
    if (nuovaPassword.length < 8) { setErrore('La password deve avere almeno 8 caratteri'); return }
    if (nuovaPassword !== confermaPassword) { setErrore('Le password non coincidono'); return }
    setCaricamento(true)
    setErrore('')
    const { error } = await supabase.auth.updateUser({ password: nuovaPassword })
    setCaricamento(false)
    if (error) { setErrore('Errore: ' + error.message); return }
    setNuovaPassword('')
    setConfermaPassword('')
    toast_msg('Password aggiornata!')
  }

  const PIANO_COLOR = {
    atleta: { bg: 'rgba(87,184,255,0.15)', text: 'var(--accent2)' },
    coach: { bg: 'rgba(127,214,61,0.15)', text: 'var(--accent)' },
    admin: { bg: 'rgba(199,125,255,0.15)', text: 'var(--purple)' },
  }

  if (mostraRichieste) return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <TopBar
        onIndietro={() => chiudiRichieste()}
        onNotifiche={undefined}
      />
      <div className="scroll-area">
        <div style={{ fontFamily: 'Syne', fontWeight: 600, fontSize: 18, marginBottom: 4 }}>
          Richieste e segnalazioni
        </div>
        <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 12 }}>
          Chiedi nuovi esercizi, segnala bug o suggerisci miglioramenti
        </div>

        {!nuovaRichiestaOpen && (
          <button className="btn btn-primary" onClick={() => setNuovaRichiestaOpen(true)} style={{ marginBottom: 12 }}>
            + Nuova richiesta
          </button>
        )}

        {/* Form nuova richiesta */}
        {nuovaRichiestaOpen && (
          <div className="card">
            <div className="card-header">
              <div className="card-title">📩 Nuova richiesta</div>
            </div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">Categoria</label>
                <select className="form-input" value={richCategoria} onChange={e => setRichCategoria(e.target.value)} style={{ cursor: 'pointer' }}>
                  <option value="nuovo_esercizio">🏋️ Nuovo esercizio</option>
                  <option value="bug">🐛 Segnala bug</option>
                  <option value="miglioramento">💡 Suggerimento miglioramento</option>
                  <option value="altro">📝 Altro</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Titolo</label>
                <input className="form-input" type="text" value={richTitolo}
                  onChange={e => { setRichTitolo(e.target.value); setRichErrore('') }}
                  placeholder="In due parole, di cosa si tratta?" maxLength={120} />
              </div>
              <div className="form-group">
                <label className="form-label">Descrizione</label>
                <textarea className="form-input" value={richTesto}
                  onChange={e => { setRichTesto(e.target.value); setRichErrore('') }}
                  placeholder="Descrivi nel dettaglio la tua richiesta..."
                  rows={5} maxLength={2000}
                  style={{ resize: 'vertical', minHeight: 100, fontFamily: 'inherit' }} />
                <div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'right', marginTop: 2 }}>
                  {richTesto.length} / 2000
                </div>
              </div>

              {richErrore && (
                <div className="alert alert-warn"><span>!</span><span>{richErrore}</span></div>
              )}

              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-ghost" style={{ flex: 1 }}
                  onClick={() => { setNuovaRichiestaOpen(false); setRichErrore(''); setRichTitolo(''); setRichTesto('') }}>
                  Annulla
                </button>
                <button className="btn btn-primary" style={{ flex: 2 }} onClick={inviaRichiesta}
                  disabled={richInvio || !richTitolo.trim() || !richTesto.trim()}>
                  {richInvio ? '⏳ Invio...' : '📤 Invia richiesta'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Storico richieste */}
        <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 1, marginTop: 8 }}>
          Le tue richieste
        </div>

        {richiesteUtente.length === 0 ? (
          <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '24px 16px', fontSize: 13, color: 'var(--muted)' }}>
            Nessuna richiesta inviata
          </div></div>
        ) : richiesteUtente.map(r => {
          const catLabel = { nuovo_esercizio: '🏋️ Nuovo esercizio', bug: '🐛 Bug', miglioramento: '💡 Miglioramento', altro: '📝 Altro' }[r.categoria] || r.categoria
          const statoBadge = {
            aperta: { col: 'rgba(87,184,255,0.15)', text: 'var(--accent2)', label: 'In attesa' },
            completata: { col: 'rgba(74,222,128,0.15)', text: 'var(--green)', label: 'Completata' },
          }[r.stato] || { col: 'var(--surface2)', text: 'var(--muted)', label: r.stato }
          return (
            <div key={r.id} className="card">
              <div className="card-header">
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>{catLabel}</div>
                  <div className="card-title" style={{ fontSize: 14 }}>{r.titolo}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
                  <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 10, background: statoBadge.col, color: statoBadge.text }}>
                    {statoBadge.label}
                  </span>
                  {r.stato === 'aperta' && (
                    <button onClick={() => setConferma({ titolo: 'Eliminare la richiesta?', testo: 'La richiesta verrà rimossa definitivamente.', testoConferma: 'Elimina', icona: '🗑️', distruttiva: true, onConferma: () => { setConferma(null); eliminaRichiesta(r.id) } })}
                      title="Elimina richiesta"
                      style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.35)', borderRadius: 8, padding: '4px 8px', color: 'var(--red)', cursor: 'pointer', fontSize: 14 }}>
                      🗑️
                    </button>
                  )}
                </div>
              </div>
              <div className="card-body" style={{ paddingTop: 0 }}>
                <div style={{ fontSize: 12, color: 'var(--text)', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{r.testo}</div>
                {r.risposta_admin && (
                  <div style={{ marginTop: 10, padding: 10, background: 'rgba(127,214,61,0.06)', borderLeft: '3px solid var(--accent)', borderRadius: 6 }}>
                    <div style={{ fontSize: 10, color: 'var(--accent)', fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>Risposta admin</div>
                    <div style={{ fontSize: 12, color: 'var(--text)', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{r.risposta_admin}</div>
                  </div>
                )}
                <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 8 }}>
                  Inviata il {new Date(r.creata_il).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            </div>
          )
        })}
      </div>
      {conferma && <ModaleConferma {...conferma} onAnnulla={() => setConferma(null)} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  )

  if (mostraGuida) return <PaginaGuida onChiudi={() => setMostraGuida(false)} />
  if (paginaLegale) return <PaginaLegale tipo={paginaLegale} onChiudi={() => setPaginaLegale(null)} />

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <TopBar />

      <div className="scroll-area">

        {/* Avatar e piano */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '8px 0' }}>
          <div className="avatar" style={{ width: 56, height: 56, fontSize: 20, background: 'rgba(127,214,61,0.15)', color: 'var(--accent)' }}>
            {profilo?.nome?.[0]}{profilo?.cognome?.[0]}
          </div>
          <div>
            <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 18 }}>{profilo?.nome} {profilo?.cognome}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{profilo?.email}</div>
            <span className="badge" style={{ marginTop: 4, display: 'inline-block', background: PIANO_COLOR[profilo?.piano]?.bg, color: PIANO_COLOR[profilo?.piano]?.text }}>
              {profilo?.piano}
            </span>
          </div>
        </div>

        {/* Piano — Atleta: sempre gratis, nessuna azione richiesta */}
        {profilo?.piano === 'atleta' && (
          <div className="card">
            <div className="card-header"><div className="card-title">Il tuo piano</div></div>
            <div className="card-body" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ fontSize: 26 }}>🎉</div>
              <div>
                <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>Atleta — sempre gratuito</div>
                <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>Allenati da solo o in un gruppo, nessun costo.</div>
              </div>
            </div>
          </div>
        )}

        {/* Piano — Coach: Free (con limiti) o Premium, mai "scaduto/bloccato" */}
        {isCoach && profilo?.piano !== 'admin' && (() => {
          const ora = new Date()
          const giorniRimanenti = profilo?.abbonamento_al
            ? Math.ceil((new Date(profilo.abbonamento_al) - ora) / (1000 * 60 * 60 * 24))
            : null
          const formatData = (d) => d ? new Date(d).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' }) : ''
          const statoColore = coachPremium ? 'var(--green)' : 'var(--muted)'
          const statoTesto = profilo?.regalo ? 'Regalo attivo' : coachPremium ? 'Premium attivo' : 'Piano Free'

          return (
            <div className="card">
              <div className="card-header"><div className="card-title">Il tuo piano Coach</div></div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {/* Stato */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>Stato</div>
                  <span style={{ fontSize: 12, fontWeight: 700, color: statoColore, background: `${statoColore}18`, padding: '3px 10px', borderRadius: 20 }}>
                    {statoTesto}
                  </span>
                </div>

                {/* Limiti piano Free */}
                {!coachPremium && (
                  <div style={{ background: 'rgba(127,214,61,0.08)', border: '1px solid rgba(127,214,61,0.25)', borderRadius: 10, padding: '10px 12px', fontSize: 12, color: 'var(--text)', lineHeight: 1.6 }}>
                    Il piano Free include <strong>1 gruppo</strong> e fino a <strong>3 atleti</strong>, senza Adesioni. Passa a Premium per sbloccare tutto.
                  </div>
                )}

                {/* Scadenza — solo se Premium attivo */}
                {coachPremium && profilo?.abbonamento_al && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: 13, color: 'var(--muted)' }}>Rinnovo il</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: giorniRimanenti !== null && giorniRimanenti <= 7 ? 'var(--red)' : 'var(--text)' }}>
                      {formatData(profilo?.abbonamento_al)}
                      {giorniRimanenti !== null && giorniRimanenti > 0 && (
                        <span style={{ fontSize: 11, color: 'var(--muted)', marginLeft: 6 }}>({giorniRimanenti}g)</span>
                      )}
                    </div>
                  </div>
                )}

                {/* Avviso scadenza imminente — rassicurante, non bloccante */}
                {coachPremium && giorniRimanenti !== null && giorniRimanenti <= 7 && giorniRimanenti > 0 && (
                  <div style={{ background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.3)', borderRadius: 10, padding: '10px 12px', fontSize: 12, color: 'var(--yellow)', lineHeight: 1.6 }}>
                    ⚠️ Il Premium scade tra {giorniRimanenti} {giorniRimanenti === 1 ? 'giorno' : 'giorni'}. Dopo torni automaticamente al piano Free, senza perdere l'accesso all'app.
                  </div>
                )}

                {/* Pulsante upgrade/rinnovo — non per regalo */}
                {!profilo?.regalo && (
                  <button className="btn btn-primary" style={{ width: '100%' }}
                    onClick={avviaPagamento} disabled={pagamentoCaricamento}>
                    {pagamentoCaricamento ? '⏳ Attendere...' : coachPremium ? '🔄 Rinnova / Gestisci Premium' : '⚡ Passa a Premium — 6€/mese'}
                  </button>
                )}
              </div>
            </div>
          )
        })()}

        {/* Notifiche push.
            La scheda compare anche dove l'interruttore non può funzionare
            (iPhone senza app installata, permesso negato): prima in quei casi
            spariva, o restava un interruttore grigio che non reagiva al tocco,
            e non c'era modo di capire perché né cosa fare. */}
        {(pushSupportato() || serveInstallazioneIOS()) && (() => {
          const soloInstallazione = serveInstallazioneIOS()
          const bloccate = !soloInstallazione && statoPermessoPush() === 'denied'
          const interruttoreUsabile = !soloInstallazione && !bloccate
          return (
            <div className="card">
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                  <div>
                    <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>🔔 Notifiche push</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2, lineHeight: 1.5 }}>
                      {soloInstallazione ? 'Su iPhone e iPad funzionano solo con l\'app installata.'
                        : bloccate ? 'Bloccate dal browser su questo dispositivo.'
                        : notifichePushOn ? 'Attive su questo dispositivo'
                        : isCoach ? 'Ricevi un avviso quando succede qualcosa nei tuoi gruppi'
                        : 'Ricevi un avviso quando il coach programma qualcosa'}
                    </div>
                  </div>
                  {interruttoreUsabile && (
                    <button onClick={toggleNotifichePush} disabled={notifichePushCaricamento} style={{
                      width: 52, height: 28, borderRadius: 14, border: 'none', cursor: 'pointer',
                      background: notifichePushOn ? 'var(--accent)' : 'var(--surface2)',
                      opacity: notifichePushCaricamento ? 0.6 : 1,
                      position: 'relative', transition: 'background 0.3s', flexShrink: 0
                    }}>
                      <div style={{
                        width: 22, height: 22, borderRadius: '50%', background: '#fff',
                        position: 'absolute', top: 3,
                        left: notifichePushOn ? 26 : 4,
                        transition: 'left 0.3s', boxShadow: '0 1px 4px rgba(0,0,0,0.3)'
                      }} />
                    </button>
                  )}
                </div>

                {/* Niente vicoli ciechi: dove l'interruttore non c'è, c'è il come fare */}
                {soloInstallazione && (
                  <div style={{ background: 'rgba(87,184,255,0.08)', border: '1px solid rgba(87,184,255,0.25)', borderRadius: 10, padding: '10px 12px', fontSize: 12, lineHeight: 1.6 }}>
                    Tocca <strong>Condividi</strong> in basso, poi <strong>Aggiungi alla schermata Home</strong>. Apri FitProgress da quell'icona e torna qui: l'interruttore comparirà.
                  </div>
                )}
                {bloccate && (
                  <div style={{ background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.3)', borderRadius: 10, padding: '10px 12px', fontSize: 12, lineHeight: 1.6 }}>
                    {comeSbloccareNotifiche()}
                  </div>
                )}

                {pushErrore && (
                  <div className="alert alert-warn"><span>!</span><span>{pushErrore}</span></div>
                )}

                {/* Stato tecnico, mostrato solo quando le notifiche NON sono attive:
                    è la riga da leggere per capire quale pezzo manca. */}
                {!notifichePushOn && pushDiagnostica && (
                  <div style={{ fontSize: 10, color: 'var(--muted)', fontFamily: 'monospace', wordBreak: 'break-word' }}>
                    {pushDiagnostica}
                  </div>
                )}

              </div>
            </div>
          )
        })()}

        {/* Tema */}
        <div className="card">
          <div className="card-body" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>Tema</div>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{temaChiaro ? 'Tema chiaro attivo' : 'Tema scuro attivo'}</div>
            </div>
            <button onClick={toggleTema} style={{
              width: 52, height: 28, borderRadius: 14, border: 'none', cursor: 'pointer',
              background: temaChiaro ? 'var(--accent)' : 'var(--surface2)',
              position: 'relative', transition: 'background 0.3s', flexShrink: 0
            }}>
              <div style={{
                width: 22, height: 22, borderRadius: '50%', background: '#fff',
                position: 'absolute', top: 3,
                left: temaChiaro ? 26 : 4,
                transition: 'left 0.3s', boxShadow: '0 1px 4px rgba(0,0,0,0.3)'
              }} />
            </button>
          </div>
        </div>

        {/* Dati personali */}
        <div className="card">
          <div className="card-header"><div className="card-title">Dati personali</div></div>
          <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Nome</label>
              <input className="form-input" value={nome} onChange={e => setNome(e.target.value)} placeholder="Il tuo nome" />
            </div>
            <div className="form-group">
              <label className="form-label">Cognome</label>
              <input className="form-input" value={cognome} onChange={e => setCognome(e.target.value)} placeholder="Il tuo cognome" />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" value={profilo?.email || ''} disabled style={{ opacity: 0.6 }} />
            </div>
            {errore && <div className="alert alert-warn"><span>!</span><span>{errore}</span></div>}
            <button className="btn btn-primary" onClick={salvaDati} disabled={caricamento}>
              {caricamento ? 'Salvataggio...' : 'Salva dati'}
            </button>
          </div>
        </div>

        {/* Cambio password */}
        <div className="card">
          <div className="card-header"><div className="card-title">Cambia password</div></div>
          <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Nuova password</label>
              <div style={{ position: 'relative' }}>
                <input className="form-input" type={mostraPass ? 'text' : 'password'} value={nuovaPassword} onChange={e => setNuovaPassword(e.target.value)} placeholder="Almeno 8 caratteri" style={{ paddingRight: 44 }} />
                <button onClick={() => setMostraPass(!mostraPass)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', fontSize: 16 }}>
                  {mostraPass ? (<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>) : (<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>)}
                </button>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Conferma password</label>
              <input className="form-input" type={mostraPass ? 'text' : 'password'} value={confermaPassword} onChange={e => setConfermaPassword(e.target.value)} placeholder="Ripeti la password" />
            </div>
            <button className="btn btn-primary" onClick={cambiaPassword} disabled={caricamento}>
              {caricamento ? 'Aggiornamento...' : 'Aggiorna password'}
            </button>
          </div>
        </div>

        {/* Invita un amico */}
        {profilo?.piano !== 'admin' && (
          <div className="card">
            <div className="card-header"><div className="card-title">🔗 Invita un amico</div></div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
                Condividi il tuo codice personale con chi vuoi invitare. Quando si registra usando il tuo link, puoi seguire quanti amici hai portato su FitProgress.
              </div>
              {referralCode ? (<>
                <div style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 12, padding: '14px 16px', textAlign: 'center' }}>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>Il tuo codice invito</div>
                  <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 22, color: 'var(--accent)', letterSpacing: 2 }}>{referralCode}</div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 6 }}>
                    {referralUtilizzi === 0 ? 'Nessun amico invitato ancora' : `${referralUtilizzi} ${referralUtilizzi === 1 ? 'amico invitato' : 'amici invitati'}`}
                  </div>
                </div>
                <button className="btn btn-primary" onClick={condividiReferral}>
                  📲 Condividi il tuo link
                </button>
                <button onClick={() => {
                  const link = `https://fitprogress.it?ref=${referralCode}`
                  const testo = `💪 Ti invito su FitProgress, l'app per allenarti al meglio!\n\nUsa il mio codice personale per registrarti e inizia subito:\n${link}`
                  window.open(`https://wa.me/?text=${encodeURIComponent(testo)}`, '_blank')
                }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, background: '#25D366', border: 'none', borderRadius: 12, padding: '12px 16px', color: '#fff', cursor: 'pointer', fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  Invia su WhatsApp
                </button>
                <button className="btn btn-ghost" style={{ fontSize: 12 }}
                  onClick={() => { navigator.clipboard.writeText(`https://fitprogress.it?ref=${referralCode}`); toast_msg('✓ Link copiato!') }}>
                  📋 Copia link
                </button>
              </>) : (
                <button className="btn btn-primary" onClick={generaCodiceReferral} disabled={referralCaricamento}>
                  {referralCaricamento ? 'Generazione...' : '✨ Genera il tuo codice invito'}
                </button>
              )}
            </div>
          </div>
        )}

        {/* Richieste e segnalazioni */}
        <button className="btn btn-secondary" onClick={apriRichieste} style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'flex-start', padding: '14px 16px' }}>
          <span style={{ fontSize: 18 }}>💬</span>
          <span style={{ fontFamily: 'Syne', fontWeight: 600, fontSize: 14 }}>Richieste e segnalazioni</span>
        </button>

        {/* Guida */}
        <button className="btn btn-secondary" onClick={() => setMostraGuida(true)} style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'flex-start', padding: '14px 16px' }}>
          <span style={{ fontSize: 18 }}>📖</span>
          <span style={{ fontFamily: 'Syne', fontWeight: 600, fontSize: 14 }}>Guida all'app</span>
        </button>

        {/* Legale */}
        <button className="btn btn-secondary" onClick={() => setPaginaLegale('privacy')} style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'flex-start', padding: '14px 16px' }}>
          <span style={{ fontSize: 18 }}>🔒</span>
          <span style={{ fontFamily: 'Syne', fontWeight: 600, fontSize: 14 }}>Privacy Policy</span>
        </button>
        <button className="btn btn-secondary" onClick={() => setPaginaLegale('tos')} style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'flex-start', padding: '14px 16px' }}>
          <span style={{ fontSize: 18 }}>📄</span>
          <span style={{ fontFamily: 'Syne', fontWeight: 600, fontSize: 14 }}>Termini di Servizio</span>
        </button>

        {/* Logout */}
        <button className="btn btn-ghost" onClick={esci} style={{ color: 'var(--red)', borderColor: 'rgba(248,113,113,0.3)' }}>
          Esci dall'account
        </button>

        {/* Cancella account */}
        {!confermaCancellazione ? (
          <button className="btn btn-ghost"
            onClick={() => setConfermaCancellazione(true)}
            style={{ color: 'var(--muted)', borderColor: 'var(--border)', fontSize: 12, marginTop: 8 }}>
            🗑️ Cancella definitivamente account
          </button>
        ) : (
          <div className="card" style={{ border: '1px solid rgba(248,113,113,0.4)', background: 'rgba(248,113,113,0.05)' }}>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, color: 'var(--red)', textAlign: 'center' }}>
                ⚠️ Cancellazione account
              </div>
              <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
                Verranno eliminati definitivamente:
                <ul style={{ paddingLeft: 18, marginTop: 6, marginBottom: 0 }}>
                  <li>Tutti i tuoi esercizi e tracking</li>
                  <li>Le tue sessioni personali</li>
                  <li>I gruppi che hai creato (se sei coach)</li>
                  <li>Tutti i messaggi e le notifiche</li>
                  <li>Il tuo profilo e l'accesso all'app</li>
                </ul>
                <div style={{ marginTop: 8, color: 'var(--red)', fontWeight: 600 }}>L'azione è IRREVERSIBILE.</div>
              </div>
              <div className="form-group">
                <label className="form-label">Scrivi <strong>ELIMINA</strong> per confermare</label>
                <input className="form-input" value={testoConferma}
                  onChange={e => setTestoConferma(e.target.value)}
                  placeholder="ELIMINA" autoComplete="off" />
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-ghost" style={{ flex: 1 }}
                  onClick={() => { setConfermaCancellazione(false); setTestoConferma('') }}
                  disabled={cancellando}>
                  Annulla
                </button>
                <button className="btn btn-primary" style={{ flex: 1, background: 'var(--red)', borderColor: 'var(--red)' }}
                  onClick={eliminaAccount}
                  disabled={cancellando || testoConferma !== 'ELIMINA'}>
                  {cancellando ? '⏳ Eliminazione...' : 'Conferma cancellazione'}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
      {conferma && <ModaleConferma {...conferma} onAnnulla={() => setConferma(null)} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  )
}
